'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-09-14
 */
import _ from 'lodash'
import moment from 'moment'

export function dateUtilService (http) {
	return {
		stringToDate: function (dateAsString) {
			if (_.isNil(dateAsString)) {
				return dateAsString
			}
			var dateMoment = moment(dateAsString)
			if (dateMoment.isValid() === false) {
				console.error('Date ' + dateAsString + ' is not a valid date')
				return undefined
			} else {
				return dateMoment.toDate()
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/services/date-util-service.js